function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import moduleStyles from '@dtsl/css-toggle/dist/index.module.css';
export const Toggle = _ref => {
  let {
    className = '',
    identifier = '',
    labelText = '',
    disabled = false,
    defaultChecked = false,
    checked = false,
    onChange: handleChange = () => {},
    ...props
  } = _ref;
  const [isChecked, setIsChecked] = React.useState(checked || defaultChecked);
  const didMountRef = React.useRef(false);
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (didMountRef.current) {
      if (ref?.current) {
        setIsChecked(checked || defaultChecked);
        ref.current.checked = checked || defaultChecked;
      }
    } else {
      didMountRef.current = true;
    }
  }, [defaultChecked, checked]);
  const toggleClass = classNames({
    [moduleStyles['sib-toggle']]: true,
    [moduleStyles['sib-toggle--disabled']]: !!disabled,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("div", {
    className: toggleClass
  }, /*#__PURE__*/React.createElement("div", {
    className: moduleStyles['sib-toggle__switch']
  }, /*#__PURE__*/React.createElement("input", _extends({
    ref: ref,
    type: "checkbox",
    id: identifier,
    role: "switch",
    disabled: disabled
  }, props, {
    onChange: e => {
      setIsChecked(prev => !prev);
      handleChange(e);
    },
    defaultChecked: isChecked
  })), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: moduleStyles['sib-toggle__switch--slider']
  }, /*#__PURE__*/React.createElement("span", {
    className: moduleStyles['sib-toggle__switch--base-icon']
  }))), /*#__PURE__*/React.createElement("label", {
    className: `${moduleStyles['sib-toggle__label']} ${labelText ? '' : moduleStyles['sib-toggle__label-empty']}`,
    htmlFor: identifier,
    "data-checked": isChecked
  }, labelText, !labelText && /*#__PURE__*/React.createElement("span", {
    className: moduleStyles['sib-sr-only']
  }, "Toggle")));
};
Toggle.propTypes = {
  labelText: PropTypes.string,
  className: PropTypes.string,
  identifier: PropTypes.string,
  disabled: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  onChange: PropTypes.func,
  checked: PropTypes.bool
};
export default Toggle;